import React, {Component} from "react";
import {
    Col,
    Form,
    FormGroup,
    Input,
    Label,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    UncontrolledTooltip
} from "reactstrap";
import {deepCopyObject, showAxiosError, turkishToLower} from "../../helper/helper";
import {request} from "../../helper/APIUtils";
import Select from '../../../src/local_node_modules/react-select'
import '../../../src/local_node_modules/react-select/dist/react-select.css'
import Alert from "react-s-alert";
import TagsInput from "../../components/TagsInput";
import Datetime from "react-datetime";
import moment from "moment";
import {uuidGenerator} from "./erpHelper";

class
ConnectorConfigurationModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            disableSaveButton: false,
            connectionInfo:{
                recordId:null,
                ownerIp:null,
                dbPort:null,
                dbUser:null,
                dbPassword:null,
                erpRecordId:null,
                dataSource: null,
                initialCatalog:null,
                periodNo:null,
                companyNo:null,
                invoiceLength:null,
                archiveXslt:null,
                invoiceXslt:null,
                despatchXslt:null,
                key:null

            },
            erpTypeList:{},
            selectedBranchId:null,
            isBranchLoading:false,
            selectedProfile:null,
            selectedProfileName:null,
            isValid:false,
            errors:{},
            activeTab: "temelbilgiler",
            hesapPlaniOwnList:[],
            selectedStok: false,
            accountingUserList:[],
            accountingUserLoading:false
        };
        this.onChangeStokSelected = this.onChangeStokSelected.bind(this);
        this.updateIsStockAccounting = this.updateIsStockAccounting.bind(this);
    }

    componentDidMount() {
        this.getTypes();
    }

    onChangeStokSelected() {
        let self = this;
        let selected = self.state.selectedStok;

        if (selected) {
            self.setState({selectedStok: false});
        } else {
            self.setState({selectedStok: true});
        }
    }

    onChangeInput = async (e,name) =>{
        let connectionInfo = {...this.state.connectionInfo};
        // let {errors} = this.state
        if(name){
            connectionInfo[name] = e && e.value ? e.value : e;
        }else{
            const {value,name} = e.target;
            connectionInfo[name] = value;
        }
        await this.setState({connectionInfo});
        // this.validate(errors);

    }
    onChangeUnit = (e,index) =>{
        let filteredUnitList = this.state.filteredUnitList;
        filteredUnitList[index].unitCode = e.value;
        this.setState({filteredUnitList});
    }

    onParentErpChange  = (e) =>{
        let {erpTypeList,connectionInfo} = this.state;
        connectionInfo.parentErp = e.value;
        let childErp = erpTypeList.filter(erp=>{
            if(erp.isParent == false && erp.parentId == e.value){
                return erp;
            }
        })
        this.setState({childErp,connectionInfo});
    }
    onChildErpChange  = (e) =>{
        let {erpTypeList,connectionInfo} = this.state;
        let erpType = erpTypeList.filter(erp=>erp.recordId == e.value)

        connectionInfo.erpType = erpType[0];
        this.setState({connectionInfo});
    }
    onChangeXslt = (e,name) =>{
        let {connectionInfo} = this.state;
        connectionInfo[name] = e.value;
        this.setState({connectionInfo});

    }

    getTypes = async () =>{
        let params = {
            url: `/connector/getTypes`,
            method: "get"
        };
        try{
            const response = await request(params);
            const{erpTypeList,customerIbanList,serviceList} = response.data;
            let parentErp = erpTypeList.filter(type=>{
                return type.isParent == true
            })
            this.setState({parentErp,erpTypeList,customerIbanList,serviceList})
        }catch(error){
            showAxiosError(error);
        }

    }

    readErpAccountingUserFromErp = (key) =>{
        this.setState({accountingUserLoading:true});
        if (key.length > 0) {
            let params = {
                url: `/connector/getErpAccountingUser`,
                method: "post",
                data: key
            };
            request(params)
                .then(response => {
                    this.send(response.data,"READ_ERP_MUHASEBE_USER")
                }).catch(function (error) {
                showAxiosError(error);
            });
        } else {
            this.setState({accountingUserList:[]});
        }
    }

    getConnectorInformation = async (branchId) =>{
        const self = this;
        self.setState({isBranchLoading:true})

        let params = {
            url: `/connector/getCustomerConnector/${branchId}`,
            method: "get"
        };
        try{
            const response = await request(params);
            if(Object.keys(response.data.body).length != 0) {
                let connectionInfo = response.data.body.customerConnector;
                let userDespatchAliasList = response.data.body.userDespatchAliasList;
                let userInvoiceAliasList = response.data.body.userInvoiceAliasList;
                let unitCodes = response.data.body.unitCodes;
                let invoiceTags = []
                let despatchTags = []
                let erpAccountingUser = {};
                if(connectionInfo.invoicePrefix && connectionInfo.invoicePrefix.length>0){
                    invoiceTags = connectionInfo.invoicePrefix.split(',');
                }
                if(connectionInfo.despatchPrefix && connectionInfo.despatchPrefix.length>0){
                    despatchTags = connectionInfo.despatchPrefix.split(',');
                }
                if(connectionInfo.erpType!=null){
                    let erpTypeList = this.state.erpTypeList;
                    let erpType = connectionInfo.erpType;
                    let childErp = erpTypeList.filter(erp=>{
                        if(erp.isParent == false && erp.parentId == erpType.parentId){
                            return erp;
                        }
                    })
                    connectionInfo.parentErp = childErp[0].parentId
                    this.setState({childErp})
                }
                if(connectionInfo.erpUser !== null){
                    erpAccountingUser = JSON.parse(connectionInfo.erpUser);
                }
                self.setState({connectionInfo,invoiceTags,despatchTags,userDespatchAliasList,userInvoiceAliasList,unitCodes,erpAccountingUser})
                await this.listenWebSocket();
            }
        }catch(error){
            showAxiosError(error);
        }
        self.setState({isBranchLoading:false})
    }

    erpAccountingUserChange(e) {
        let erpAccountingUser = this.state.erpAccountingUser;
        erpAccountingUser = {
            "username": e ? e.label : null,
            "userCode": e ? e.value : null
        };
        this.setState({erpAccountingUser: erpAccountingUser});
    }

    saveClicked = async () => {

        let self = this;

        if(this.state.connectionInfo.showAccountingReceipt){
            self.writeHesapPlani();
            self.updateIsStockAccounting();
        }


        let selectedBranchId = self.state.selectedBranchId;
        self.setState({disableSaveButton: true});
        let error = self.validate();
        if (!error) {
            self.setState({disableSaveButton: false});
        } else {
            let information = this.state.connectionInfo;
            information.startDate = information.startDate !== null && information.startDate.trim().length == 0
                ? null : information.startDate;
            information.erpUser = self.state.erpAccountingUser !== null ? JSON.stringify(self.state.erpAccountingUser) : null;
            let params = {
                url: `/connector/saveCustomerConnector/${selectedBranchId}`,
                method: 'post',
                data: information
            };
            try{
                await request(params);
                Alert.success('Başarılı bir şekilde kayıt edildi', {
                    position:'top-right',
                    effect: 'stackslide',
                    timeout: 5000
                });
                self.props.toggle();
                self.clearInputs();
            }catch (error){
                self.setState({disableSaveButton: false});
                showAxiosError(error);
            }

        }
    }
    onClickBranchBtn = (e) =>{
        const oldSelectedBranch = document.getElementById(`${this.state.selectedBranchId}`);
        const disabled = document.getElementsByClassName("connector-invoice-list-item disabled");
        Array.from(disabled).forEach(dis=> {
            dis.classList.remove("disabled")
        });
        if(oldSelectedBranch!=null) oldSelectedBranch.style.backgroundColor = 'white'
        e.target.style.background = '#6bd0f3';

        this.clearInputs();
        this.setState({selectedBranchId:e.target.id})
        this.getConnectorInformation(e.target.id);
        if(this.state.activeTab === "HesapPlani"){this.getOwnList(e.target.id)}
    }

    validate = (errors=null) => {
        let information = this.state.connectionInfo;
        if(information.invoicePrefix){
            information.invoicePrefix = information.invoicePrefix.trim()
        }else{
            information.invoicePrefix = ""
        }
        let needCheck = {
            "erpType":["notNull"],"ownerIp":["notNull"],"dataSource":["notNull"],
            "initialCatalog":["notNull"],"dbUser":["notNull"],"dbPassword":["notNull"],
            "startDate":["date"],"connectionType":["notNull"],"parentErp":["notNull"],
            "erpRecordId":["notNull"]
        };
        let sendError = true;

        if(errors){
            let arr = [];
            for (const value in errors) {
                arr.push(value);
            }
            needCheck = arr;
            sendError = false;
        }

        let error = "";
        errors = {};
        Object.keys(needCheck).forEach(key=>{
            needCheck[key].forEach(control=>{
                if(control == "notNull" && (information[key] === null)){
                    errors[key] = `boş olamaz`
                }else if(control == "date" && information[key]!== null && information[key].trim().length !== 0 &&
                    !moment(information[key],"YYYY-MM-DD",true).isValid()){
                    errors[key] = `tarih formatı uygun değil`
                }
            })
        })

        this.setState({errors,connectionInfo:information})

        if(Object.keys(errors).length !=0){
            if(sendError) showAxiosError({message: "Devam etmek için hatalı alanları düzeltiniz."});
            return false;
        }
        return true;
    }
    selectedTags = (tags,type) => {
        const {connectionInfo} = this.state;
        if(type === "invoice"){
            connectionInfo.invoicePrefix = tags.toString();
            this.setState({invoiceTags:tags})
        }else if(type === "despatch"){
            connectionInfo.despatchPrefix = tags.toString();
            this.setState({despatchTags:tags})
        }
    };
    clearInputs = () =>this.setState({
        connectionInfo:{},selectedBranchId:null,errors:{},erpAccountingUser:{},
        invoiceTags:undefined,despatchTags:undefined,status:null,
        filteredUnitList:null,unitList:null
    });
    toggle = (tab) => {
        if (this.state.activeTab !== tab) {
            this.setState({activeTab: tab});
        }
    }
    getUnitSql = async (outbox)=> {
        let self = this;

        self.setState({status:{
                state:null,
                message:"Sorgu oluşturuluyor."
        }});

        let params = {
            url: `/connector/getUnitSql`,
            method: "get"
        };
        try{
            let {data} = await request(params);
            if(data){
                self.setState({getUnitSql:data,status:{
                        state:null,
                        message:"Sql komutu oluşturuldu."
                }});
                self.send(data,"GET_UNITLIST");
                return data;
            }
        }catch(error){
            let err = {response:{data:"Kayıt Hatası"}}
            showAxiosError(err);
        }
    }

    async getHesapPlani(key) {
        let self = this;
        if (key.length > 0) {
            let params = {
                url: "/hesapPlani/getHesapPlani/" + key,
                method: "get"
            };

            await request(params).then((response) => {
                    if (response && response.data) {
                        self.send(response.data, "READ_HESAP_PLANI");
                    }
                }
            ).catch((exception) => {
                showAxiosError(exception);
            });
        } else {
            this.setState({hesapPlaniValues: []});
            return Promise.resolve({options: []});
        }
    }

    getALLHesapPlani () {
        let self = this;

            let params = {
                url: "/hesapPlani/getALLHesapPlani",
                method: "get"
            };

            request(params).then((response) => {
                    if (response && response.data) {
                        self.send(response.data, "READ_ALL_HESAP_PLANI");
                    }
                }
            ).catch((exception) => {
                showAxiosError(exception);
            });
    }

    writeHesapPlani () {
        let self = this;

        let branchId = self.state.selectedBranchId;
        let reqList = [];
        reqList = deepCopyObject(this.state.hesapPlaniOwnList);

        let params = {
            url: `/hesapPlani/writeHesapPlani/${branchId}`,
            method: "post",
            data: reqList
        };

        request(params).then((response) => {
                if (response && response.data) {

                }
            }
        ).catch((exception) => {
            showAxiosError(exception);
        });
    }

    updateIsStockAccounting() {
        let selected = this.state.selectedStok;

        let params = {
            url: "/user/updateIsStockAccounting",
            method: "post",
            data: selected
        }

        request(params).then((response) => {
            console.log("Response")
        })
    }

    getOwnList (branchId) {
        let self = this;
        let params = {
            url: `/hesapPlani/getOwnList/${branchId}`,
            method: "get"
        };

        request(params).then((response) => {
                if (response && response.data) {
                    self.setState({hesapPlaniOwnList: response.data});
                }
            }
        ).catch((exception) => {
            showAxiosError(exception);
        });
    }

    listenWebSocket = async () =>{
        let self = this;
        let {connectionInfo} = this.state;
        const ws = new WebSocket(connectionInfo.ownerIp + "/websocket/chat");
        this.setState({ws});

        ws.onopen = async () => {
            self.setState({status:{
                state:"connected",
                message:"Servis Bağlantı Kuruldu."
            }});
        }

        ws.onmessage = evt => {
            let {queryType,rows,uuid} = JSON.parse(evt.data)
            rows = JSON.parse(rows);
            if(queryType == "ERROR" && rows && rows[0].error){
                console.log(rows[0].error);
                Alert.error("Hata Oluştu", {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 3000
                });
                this.setState({searching:false})
            } else if((queryType === "GET_UNITLIST") && rows != null){
                let information = this.state.connectionInfo;
                let erpUnitList = information.erpUnitList;
                let unitList = rows.filter(unit=>{
                    if(!erpUnitList.find(o => o.referenceId == unit.referenceId)){
                        return unit;
                    }
                })
                this.setState({unitList,filteredUnitList:unitList,status:{
                        state:"ok",
                        message:"İşlem Başarılı."
                }});
            }else if((queryType === "READ_INVOICE") && rows != null ) {

                if (rows.length === 0) {
                    Alert.success("Ara kriterlerine uygun fatura bulunamadı.", {
                        position: 'bottom-right',
                        effect: 'stackslide',
                        timeout: 4000
                    });
                }
                self.setState({outboxList:rows,searching:false,index:0});

                if(rows.length>0 && this.state.saveClicked){
                    this.confirm();
                }
            }else if((queryType === "READ_HESAP_PLANI") && rows != null ) {
                if (rows.length === 0) {
                    Alert.success("Arama kriterlerine uygun hesap planı bulunamadı.", {
                        position: 'bottom-right',
                        effect: 'stackslide',
                        timeout: 4000
                    });
                }

                let values = rows;
                let options = values.map(i => ({
                    value: i.kod,
                    name:
                        (i.aciklama== null ? "": i.aciklama)
                        +"½"+
                        (i.Vergikimlikno==null ? "": i.Vergikimlikno)
                            +"½"+
                        (i.Tckimlikno==null?"":i.Tckimlikno),
                    label: i.kod + "-" + i.aciklama

                }));

                self.setState({hesapPlaniValues:options});
            }else if((queryType === "READ_ALL_HESAP_PLANI") && rows != null ) {

                if (rows.length === 0) {
                    Alert.success("Arama kriterlerine uygun hesap planı bulunamadı.", {
                        position: 'bottom-right',
                        effect: 'stackslide',
                        timeout: 4000
                    });
                }
                self.setState({hesapPlaniValues:rows});
                console.log(self.state.hesapPlaniValues);
            } else if ((queryType === "READ_ERP_MUHASEBE_USER") && rows !== null) {
                if (rows.length === 0) {
                    Alert.success("Arama kriterlerine uygun kullanıcı bulunamadı.", {
                        position: 'bottom-right',
                        effect: 'stackslide',
                        timeout: 4000
                    });
                    self.setState({accountingUserList: [], accountingUserLoading: false});
                }
                let userList = rows;
                let options = userList.map(user => ({
                    value: user.userCode,
                    label: user.username
                }));
                self.setState({accountingUserList: options, accountingUserLoading: false});
            }
        }

        ws.onclose = () => {
            this.setState({status:{
                    state:"disconnected",
                    message:"Servis Bağlantısı Koptu."
            }});
        }
    }
    send = (query,queryType,documentUuid) =>{
        const {customer} = this.props;
        const {connectionInfo} = this.state;

        let header = {
            customerId: customer.recordId,
            dataSource: connectionInfo.dataSource,
            initialCatalog: connectionInfo.initialCatalog,
            dbUser: connectionInfo.dbUser,
            dbPassword: connectionInfo.dbPassword,
            key: connectionInfo.key,
            branchId: connectionInfo.branchId,
            clientType:"PORTAL"
        }
        let body = {
            uuid:documentUuid?documentUuid: uuidGenerator(),
            queryType: queryType,
            query: query
        };

        let ws = this.state.ws;
        let jsonMsg = JSON.stringify({header,body})
        console.log(jsonMsg,'jsonMsg');
        ws.send(jsonMsg);
        this.setState({status:{
                state:null,
                message:"Sorgu Gönderildi. Yanıt bekleniyor..."
        }});
    }
    saveUnit = async (unit,index) => {
        let self = this;
        let connectionInfo = this.state.connectionInfo;
        let filteredUnitList = this.state.filteredUnitList;
        let params = {
            url: `/connector/saveUnit/` + connectionInfo.branchId,
            method: "post",
            data:unit
        };
        try{
            let {data} = await request(params);
            let connectionInfo = self.state.connectionInfo;
            connectionInfo.erpUnitList = data;
            filteredUnitList = filteredUnitList.filter(erp=>erp.referenceId != unit.referenceId)
            this.setState({connectionInfo,filteredUnitList});
        }catch(error){
            let err = {response:{data:"Kayıt Hatası"}}
            showAxiosError(err);
        }

    }
    deleteUnit = async (unit) => {
        let self = this;
        let connectionInfo = self.state.connectionInfo;
        let params = {
            url: `/connector/deleteUnit/` + connectionInfo.branchId,
            method: "post",
            data:unit
        };
        try{
            let {data} = await request(params);
            let connectionInfo = self.state.connectionInfo;
            connectionInfo.erpUnitList = data;
            this.setState({connectionInfo});
        }catch(error){
            let err = {response:{data:"Silerken bir hata ile karşılaşıldı."}}
            showAxiosError(err);
        }
    }
    erpFilter = (e) =>{
        let unitList = this.state.unitList;
        if(unitList && unitList.length>0){
            unitList = unitList.filter(unit=>{
                if(turkishToLower(unit.erpUnitName).includes(turkishToLower(e.target.value)) ||
                    turkishToLower(unit.erpUnitCode).includes(turkishToLower(e.target.value))){
                    return unit;
                }
            });
            this.setState({filteredUnitList:unitList});
        }
    }
    unitNameConverter = (code) =>{
        let unitCodes = this.state.unitCodes;
        if(unitCodes && unitCodes.length>0){
            let unit = unitCodes.filter(unit=>{
                return unit.shortCode === code
            })
            return unit[0].longCode;
        }
        return '';
    }

    arrowRenderer(e) {
        let onMouseDown = e.onMouseDown;
        return React.createElement('span', {
            className: 'search',
            onMouseDown: onMouseDown
        });
    }

    onHesapPlaniChange(data, index) {
        let self = this;

        let currentList = deepCopyObject(this.state.hesapPlaniOwnList);
        let hesapPlani = data;

        let arr = [];

        if(data){
            data.name.split("½").forEach((i) => arr.push(i));

            currentList[index].hesapKodu = hesapPlani.value;
            currentList[index].hesapAdi = arr[0];
            currentList[index].vkn = arr[1]==="" ? null : arr[1];
            currentList[index].tckn = arr[2]==="" ? null : arr[2];
        } else {
            currentList[index].hesapKodu = null;
            currentList[index].hesapAdi = null;
            currentList[index].vkn = null;
            currentList[index].tckn = null;
        }

        self.setState({hesapPlaniOwnList:currentList});
    }

    render() {
        let connectionInfo = deepCopyObject(this.state.connectionInfo);
        const customerBranchList = this.props.customer.customerBranchList;
        //const erpType123 =  this.state.connectionInfo?.erpType.name;
        const {parentErp,childErp,selectedBranchId,isBranchLoading,customerIbanList,serviceList,
            userDespatchAliasList,userInvoiceAliasList,errors,status,filteredUnitList,hesapPlaniOwnList} = this.state;
        const invoiceLengthList = [
            {value:20,label:20},{value:50,label:50},{value:100,label:100},{value:250,label:250}
        ]
        const connectionType = [
            {value:"WEBSOCKET",label:"Websocket"},
            {value:"WINSERVICE",label:"Windows Servisi"}
        ]

        const profileIdList = [
            {value: "TEMELFATURA", label: "Temel Fatura"},
            {value: "TICARIFATURA", label: "Ticari Fatura"},
        ]
        return (
            <Modal isOpen={this.props.isOpen} size="md" style={{minWidth: '70%'}}>
            <ModalHeader
                toggle={() => {this.clearInputs(); this.toggle('temelbilgiler'); this.props.toggle()}}
                className="justify-content-center">
                Konnektör Bilgileri
            </ModalHeader>
            <ModalBody className="connector-configuration-modal-body">
                <div className="modal-branch-btn-container">
                    <div className="alert alert-info branch-btn" role="alert">
                        Şube Listesi
                    </div>
                    <ul className="list-group">
                        {customerBranchList && customerBranchList.length>0 && customerBranchList.map(branch =>(
                            <li className = {`list-group-item branch-btn ${isBranchLoading ? 'disabled':''} `} key={branch.recordId} id={branch.recordId} onClick={this.onClickBranchBtn}>{branch.branchName}</li>
                        ))}
                    </ul>
                </div>

                {selectedBranchId== null &&
                    <div className="alert alert-danger" role="alert" style={{width:"70%",height:"fit-content"}}>
                        Lütfen önce sol taraftan bir şube seçiniz!
                    </div>
                }
                {selectedBranchId!= null &&
                    <div className="card-nav-tabs card-plain w-100">
                        <div className="card-header card-header-danger">
                            <div className="nav-tabs-navigation">
                                <div className="nav-tabs-wrapper">
                                    <ul className="nav tabBackground nav-tabs" data-tabs="tabs">
                                        <li className="nav-item">
                                            <a className={"nav-link " + (this.state.activeTab === 'temelbilgiler' ? 'active' : '')}
                                               onClick={() => {this.toggle('temelbilgiler')}}
                                               data-toggle="tab">Bağlantı Bilgileri</a>
                                        </li>
                                        <li className="nav-item">
                                            <a className={"nav-link " + (this.state.activeTab === 'varsayilan' ? 'active' : '')}
                                               onClick={() => {this.toggle('varsayilan')}}
                                               data-toggle="tab">Varsayılan Değerler</a>
                                        </li>
                                        <li className="nav-item">
                                            <a className={"nav-link " + (this.state.activeTab === 'xslt' ? 'active' : '')}
                                               onClick={() => {this.toggle('xsltsecimi')}}
                                               data-toggle="tab">XSLT Seçimi</a>
                                        </li>
                                        <li className="nav-item">
                                            <a className={"nav-link " + (this.state.activeTab === 'xslt' ? 'active' : '')}
                                               onClick={() => {this.toggle('birimleriYonet')}}
                                               data-toggle="tab">Birimleri Yönet</a>
                                        </li>

                                        {this.state.connectionInfo.showAccountingReceipt &&
                                        <li className="nav-item" onClick={()=>this.getOwnList(this.state.selectedBranchId)}>
                                            <a className={"nav-link " + (this.state.activeTab === 'HesapPlani' ? 'active' : '') }
                                               onClick={() => {this.toggle('HesapPlani')}}
                                               data-toggle="tab" >Hesap Planı</a>
                                        </li>}
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="card-body">
                            <div className="tab-content">
                                <div className={"tab-pane " + (this.state.activeTab === 'temelbilgiler' ? 'active' : '')} id="temelbilgiler">
                                    <div className="col-sm-12">
                                        <Form className="connector-configuration-form needs-validation" >
                                            {parentErp && parentErp.length >0 &&
                                                <FormGroup row>
                                                    <Label sm={4} for="parentErp">Konnektör Tipi *</Label>
                                                    <Col xs="8">
                                                        <Select
                                                            disabled={selectedBranchId==null || isBranchLoading || connectionInfo.erpType}
                                                            id="parentErp"
                                                            style={errors.parentErp !=null ? {border:"1px solid red"} : {display:'flex',alignItems:'center',justifyContent:'space-between'}}
                                                            name="parentErp"
                                                            value={connectionInfo.parentErp}
                                                            clearable={false}
                                                            clearValueText="Temizle"
                                                            placeholder="Seçiniz..."
                                                            options={parentErp.map(erpType => ({
                                                                value: erpType.recordId,
                                                                label: erpType.name
                                                            }))}
                                                            onChange={(e) => {
                                                                this.onParentErpChange(e)
                                                            }}>
                                                        </Select>
                                                        <span style={{fontSize:"90%"}}>{errors.parentErp}</span>
                                                    </Col>

                                                </FormGroup>
                                            }
                                            <FormGroup row>
                                                <Label sm={4} for="software">Kullanıcı Adı *</Label>
                                                <Col sm={8}>
                                                    <Input disabled={selectedBranchId==null || isBranchLoading} type="text" name="dbUser" value={connectionInfo.dbUser || ''}
                                                           onChange={(e) => this.onChangeInput(e)} style={errors.dbUser && {border:"1px solid red"}} />
                                                    <span style={{fontSize:"90%"}}>{errors.dbUser}</span>
                                                </Col>
                                            </FormGroup>
                                            <FormGroup row>
                                                <Label sm={4} for="erpRecordId">Sürüm *</Label>
                                                <Col xs="8">
                                                    <Select
                                                        disabled={connectionInfo.parentErp == null}
                                                        id="erpRecordId"
                                                        style={errors.erpType != null ? {border:"1px solid red"} : {display:'flex',alignItems:'center',justifyContent:'space-between'}}
                                                        name="erpRecordId"
                                                        value={connectionInfo.erpType?connectionInfo.erpType.recordId:''}
                                                        clearable={false}
                                                        clearValueText="Temizle"
                                                        placeholder="Seçiniz..."
                                                        options={childErp && childErp.map(erpType => ({
                                                            value: erpType.recordId,
                                                            label: erpType.name
                                                        }))}
                                                        onChange={(e) => this.onChildErpChange(e)}>
                                                    </Select>
                                                    <span style={{fontSize:"90%"}}>{errors.erpRecordId}</span>
                                                </Col>
                                            </FormGroup>
                                            <FormGroup row>
                                                <Label sm={4} for="software">Kullanıcı Şifre *</Label>
                                                <Col sm={8}>
                                                    <Input disabled={selectedBranchId==null || isBranchLoading} type="password" name="dbPassword" value={connectionInfo.dbPassword || ''}
                                                           onChange={(e) => this.onChangeInput(e)} style={errors.dbPassword && {border:"1px solid red"}}/>
                                                    <span style={{fontSize:"90%"}}>{errors.dbPassword}</span>
                                                </Col>
                                            </FormGroup>
                                            <FormGroup row>
                                                <Label sm={4} for="name">Ip Bilgisi *</Label>
                                                <Col sm={8}>
                                                    <input disabled={selectedBranchId==null || isBranchLoading} type="text" name="ownerIp" value={connectionInfo.ownerIp || ''}
                                                           onChange={(e) => this.onChangeInput(e)}  className="form-control" style={errors.ownerIp && {border:"1px solid red"}}/>
                                                    {errors.ownerIp &&
                                                        <span style={{fontSize:"90%"}}>{errors.ownerIp}</span>
                                                    }
                                                </Col>
                                            </FormGroup>
                                            <FormGroup row>
                                                <Label sm={4} for="name">Bağlantı Türü *</Label>
                                                {connectionType &&
                                                    <Col xs="8">
                                                        <Select
                                                            disabled={selectedBranchId==null || isBranchLoading}
                                                            id="connectionType"
                                                            style={errors.connectionType != null ? {border: "1px solid red"} : {
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'space-between'
                                                            }}
                                                            name="connectionType"
                                                            value={connectionInfo.connectionType || "WINSERVICE"}
                                                            clearable={false}
                                                            clearValueText="Temizle"
                                                            placeholder="Seçiniz..."
                                                            options={connectionType}
                                                            onChange={(e) => this.onChangeInput(e, 'connectionType')}>
                                                        </Select>
                                                        <span style={{fontSize: "90%"}}>{errors.connectionType}</span>
                                                    </Col>
                                                }
                                            </FormGroup>
                                            <FormGroup row>
                                                <Label sm={4} for="name">Sunucu Adı *</Label>
                                                <Col sm={8}>
                                                    <Input disabled={selectedBranchId==null || isBranchLoading} type="text" name="dataSource" value={connectionInfo.dataSource || ''}
                                                           onChange={(e) => this.onChangeInput(e)} style={errors.dataSource && {border:"1px solid red"}}/>
                                                    <span style={{fontSize:"90%"}}>{errors.dataSource}</span>
                                                </Col>
                                            </FormGroup>
                                            <FormGroup row>
                                                <Label sm={4} for="name">Key</Label>
                                                <Col sm={8}>
                                                    <Input disabled={selectedBranchId==null || isBranchLoading} type="text" name="key" value={connectionInfo.key || ''}
                                                           onChange={(e) => this.onChangeInput(e)}/>
                                                </Col>
                                            </FormGroup>
                                            <FormGroup row>
                                                <Label sm={4} for="surname">Database Adı *</Label>
                                                <Col sm={8}>
                                                    <Input disabled={selectedBranchId==null || isBranchLoading} type="text" name="initialCatalog" value={connectionInfo.initialCatalog || ''}
                                                           onChange={(e) => this.onChangeInput(e)} style={errors.initialCatalog && {border:"1px solid red"}}/>
                                                    <span style={{fontSize:"90%"}}>{errors.initialCatalog}</span>
                                                </Col>
                                            </FormGroup>
                                        </Form>
                                    </div>
                                </div>
                                <div className={"tab-pane " + (this.state.activeTab === 'varsayilan' ? 'active' : '')} id="varsayilan">
                                    <div className="col-sm-12">
                                        <Form className="connector-configuration-form needs-validation row" >
                                            <div className="col-md-6">
                                                <FormGroup row>
                                                    <Label sm={4} for="name">Firma Numarası </Label>
                                                    <Col sm={8}>
                                                        <Input disabled={selectedBranchId==null || isBranchLoading} type="text" name="companyNo" value={connectionInfo.companyNo || ''}
                                                               onChange={(e) => this.onChangeInput(e)}/>
                                                    </Col>
                                                </FormGroup>
                                                <FormGroup row>
                                                    <Label sm={4} for="name">Dönem Numarası </Label>
                                                    <Col sm={8}>
                                                        <Input disabled={selectedBranchId==null || isBranchLoading} type="text" name="periodNo" value={connectionInfo.periodNo || ''}
                                                               onChange={(e) => this.onChangeInput(e)}/>
                                                    </Col>
                                                </FormGroup>
                                                <FormGroup row>
                                                    <Label sm={4} for="name">
                                                        Fatura Ön Ek <i className="fa fa-question-circle" id="invoiceTags" style={{paddingLeft: '3px'}} aria-hidden="true"/>
                                                    </Label>
                                                    <Col xs="8">{
                                                        this.state.invoiceTags != undefined && <TagsInput selectedTags={this.selectedTags} type="invoice" tags={this.state.invoiceTags}/>
                                                    }
                                                        <UncontrolledTooltip placement="right" target={"invoiceTags"} delay={0}>
                                                            Ön ek girdikten sonra enter tuşuna basınız. Birden fazla ön ek girebilirsiniz.
                                                            Burada girilen ön eklere ait faturalar filtrelenecek ve getirilecektir.
                                                        </UncontrolledTooltip>
                                                    </Col>
                                                </FormGroup>
                                                <FormGroup row>
                                                    <Label sm={4} for="name">
                                                        İrsaliye Ön Ek <i className="fa fa-question-circle" id="despatchTags" style={{paddingLeft: '2px'}} aria-hidden="true"/>
                                                    </Label>
                                                    <Col xs="8">{
                                                        this.state.despatchTags != undefined && <TagsInput selectedTags={this.selectedTags} type="despatch"  tags={this.state.despatchTags}/>
                                                    }
                                                        <UncontrolledTooltip placement="right" target={"despatchTags"} delay={0}>
                                                            Ön ek girdikten sonra enter tuşuna basınız. Birden fazla ön ek girebilirsiniz.
                                                            Burada girilen ön eklere ait faturalar filtrelenecek ve getirilecektir.
                                                        </UncontrolledTooltip>
                                                    </Col>
                                                </FormGroup>
                                                <FormGroup row>
                                                    <Col sm={1} className="d-flex">
                                                        <input type="checkbox" name="invoiceNumberFrom"
                                                               checked={connectionInfo.invoiceIdFrom!=null&&connectionInfo.invoiceIdFrom === "ERP"}
                                                               onChange={e => {e.target.checked
                                                                   ?this.onChangeInput({value:"ERP"},'invoiceIdFrom')
                                                                   :this.onChangeInput({value:"PORTAL"},'invoiceIdFrom')
                                                               }}/>
                                                    </Col>
                                                    <Label sm={10} for="invoiceNumberFrom">Fatura Numarası Erp'den Çekilsin</Label>
                                                </FormGroup>
                                                <FormGroup row>
                                                    <Col sm={1} className="d-flex">
                                                        <input type="checkbox" name="despatchIdFrom"
                                                               checked={connectionInfo.despatchIdFrom!=null&&connectionInfo.despatchIdFrom === "ERP"}
                                                               onChange={e => {e.target.checked
                                                                   ?this.onChangeInput({value:"ERP"},'despatchIdFrom')
                                                                   :this.onChangeInput({value:"PORTAL"},'despatchIdFrom')
                                                               }}/>
                                                    </Col>
                                                    <Label sm={10} for="despatchIdFrom">İrsaliye Numarası Erp'den Çekilsin</Label>
                                                </FormGroup>
                                                <FormGroup row>
                                                    <Col sm={1} className="d-flex">
                                                        <input type="checkbox" name="showAccountingReceipt"
                                                               checked={this.state.connectionInfo.showAccountingReceipt}
                                                               onChange={e => {
                                                                   this.onChangeInput(e.target.checked, 'showAccountingReceipt');
                                                               }}/>
                                                    </Col>
                                                    <Label sm={10} for="showAccountingReceipt">Muhasebe Fiş Aktarım</Label>
                                                </FormGroup>
                                                {this.state.connectionInfo.showAccountingReceipt &&
                                                <FormGroup row>
                                                    <Col sm={1} className="d-flex">
                                                        <input type="checkbox" name="accountingReceiptWithDiscount"
                                                               checked={this.state.connectionInfo.accountingReceiptWithDiscount}
                                                               onChange={e => {
                                                                   this.onChangeInput(e.target.checked, 'accountingReceiptWithDiscount');
                                                               }}/>
                                                    </Col>
                                                    <Label sm={10} for="accountingReceiptWithDiscount">Muhasebe Fiş Aktarım İskonto Dahil Edilsin</Label>
                                                </FormGroup>}
                                            </div>
                                            <div className="col-md-6">
                                                {serviceList && serviceList["EFATURA"] &&
                                                    <FormGroup row>
                                                        <Label sm={4} for="name">Fatura Etiketi </Label>
                                                        {userInvoiceAliasList && userInvoiceAliasList.length>0 &&
                                                            <Col xs="8">
                                                                <Select
                                                                    id="userInvoiceGB"
                                                                    style={{display:'flex',alignItems:'center',justifyContent:'space-between'}}
                                                                    name="userInvoiceGB"
                                                                    value={connectionInfo.userInvoiceGB}
                                                                    clearable={false}
                                                                    clearValueText="Temizle"
                                                                    placeholder="Seçiniz..."
                                                                    options={userInvoiceAliasList.map(alias => ({
                                                                        value: alias.workScopecode,
                                                                        label: alias.workScopecode
                                                                    }))}
                                                                    onChange={(e) => this.onChangeInput(e,'userInvoiceGB')}>
                                                                </Select>
                                                            </Col>
                                                        }
                                                    </FormGroup>
                                                }
                                                {serviceList && serviceList["EIRSALIYE"] &&
                                                    <FormGroup row>
                                                        <Label sm={4} for="name">İrsaliye Etiketi </Label>
                                                        {userDespatchAliasList && userDespatchAliasList.length>0 &&
                                                            <Col xs="8">
                                                                <Select
                                                                    id="userDespatchGB"
                                                                    style={{display:'flex',alignItems:'center',justifyContent:'space-between'}}
                                                                    name="userDespatchGB"
                                                                    value={connectionInfo.userDespatchGB}
                                                                    clearable={false}
                                                                    clearValueText="Temizle"
                                                                    placeholder="Seçiniz..."
                                                                    options={userDespatchAliasList.map(alias => ({
                                                                        value: alias.workScopecode,
                                                                        label: alias.workScopecode
                                                                    }))}
                                                                    onChange={(e) => this.onChangeInput(e,'userDespatchGB')}>
                                                                </Select>
                                                            </Col>
                                                        }
                                                    </FormGroup>
                                                }
                                                <FormGroup row>
                                                    <Label sm={4} for="name">IBAN Numarası </Label>
                                                    {customerIbanList && customerIbanList.length>0 &&
                                                        <Col xs="8">
                                                            <Select
                                                                disabled={selectedBranchId==null || isBranchLoading}
                                                                id="paymentFinancialAccountId"
                                                                className="select-control"
                                                                name="paymentFinancialAccountId"
                                                                value={connectionInfo.paymentFinancialAccountId}
                                                                clearable={true}
                                                                clearValueText="Temizle"
                                                                placeholder="Seçiniz..."
                                                                options={customerIbanList.map(customerIban => ({
                                                                    value: customerIban.iban,
                                                                    label: customerIban.iban
                                                                }))}
                                                                onChange={(e) => this.onChangeInput(e,'paymentFinancialAccountId')}>
                                                            </Select>
                                                        </Col>
                                                    }
                                                </FormGroup>
                                                <FormGroup row>
                                                    <Label sm={4} for="name">Kayıt Sayısı</Label>
                                                    <Col xs="8">
                                                        <Select
                                                            disabled={selectedBranchId==null || isBranchLoading}
                                                            id="invoiceLength"
                                                            style={{display:'flex',alignItems:'center',justifyContent:'space-between'}}
                                                            name="invoiceLength"
                                                            value={connectionInfo.invoiceLength?connectionInfo.invoiceLength:50}
                                                            clearable={false}
                                                            clearValueText="Temizle"
                                                            placeholder="Seçiniz..."
                                                            options={invoiceLengthList}
                                                            onChange={(e) => this.onChangeInput(e,'invoiceLength')}>
                                                        </Select>
                                                    </Col>
                                                </FormGroup>
                                                <FormGroup row>
                                                    <Label sm={4} for="name">Fatura Türü</Label>
                                                    <Col xs="8">
                                                        <Select
                                                            id="profileId"
                                                            className="select-control"
                                                            name="profileId"
                                                            value={connectionInfo.profileId}
                                                            clearable={true}
                                                            clearValueText="Temizle"
                                                            placeholder="Seçiniz..."
                                                            options={profileIdList}
                                                            onChange={(e) => this.onChangeInput(e,'profileId')}>
                                                        </Select>
                                                    </Col>
                                                </FormGroup>
                                                <FormGroup row>
                                                    <Label sm={4} for="startDate">Başlangıç Tarihi:</Label>
                                                    <Col xs="8">
                                                        <Datetime locale="tr"
                                                                  className="datepicker"
                                                                  input={true}
                                                                  closeOnSelect={true}
                                                                  value={moment(connectionInfo.startDate, "YYYY-MM-DD", true).isValid() ? moment(connectionInfo.startDate).format("DD-MM-YYYY") : connectionInfo.startDate}
                                                                  dateFormat="DD-MM-YYYY"
                                                                  timeFormat={false}
                                                                  style={errors.startDate && {border:"1px solid red"}}
                                                                  onChange={(e) => {
                                                                      this.onChangeInput((!(typeof e === "string") ? e.format("YYYY-MM-DD") : e), "startDate")
                                                                  }}/>
                                                        <span style={{fontSize:"90%",color:"red"}}>{errors.startDate}</span>
                                                    </Col>
                                                </FormGroup>
                                                {this.state.connectionInfo.showAccountingReceipt &&
                                                    <FormGroup row>
                                                        <Label sm={4} for="erpAccountingUser">ERP Muhasebe Kullanıcısı</Label>
                                                        <Col xs="8">
                                                            <Select
                                                                clearable={false}
                                                                multi={false}
                                                                className="select-control"
                                                                ignoreAccents={false}
                                                                id={this.state.erpAccountingUser.username}
                                                                 value={{
                                                                     value: this.state.erpAccountingUser.userCode,
                                                                     label: this.state.erpAccountingUser.username
                                                                 }}
                                                                onChange={(e) => e && this.erpAccountingUserChange(e)}
                                                                onInputChange={(key) => this.readErpAccountingUserFromErp(key)}
                                                                isLoading={this.state.accountingUserLoading}
                                                                autoload={false}
                                                                cache={false}
                                                                noResultsText="Kayıt bulunamadı."
                                                                searchPromptText="Arama için en az 1 karakter giriniz."
                                                                placeholder="Kullanıcı adı ile arama yapabilirsiniz"
                                                                loadingPlaceholder="Yükleniyor..."
                                                                showNewOptionAtTop={false}
                                                                arrowRenderer={this.arrowRenderer}
                                                                onCloseResetsInput={false}
                                                                onSelectResetsInput={false}
                                                                onBlurResetsInput={false}
                                                                options={this.state.accountingUserList}
                                                                />
                                                        </Col>
                                                    </FormGroup>
                                                }
                                            </div>
                                        </Form>
                                    </div>
                                </div>
                                <div className={"tab-pane " + (this.state.activeTab === 'xsltsecimi' ? 'active' : '')} id="xsltsecimi">
                                    <div className="col-sm-12">
                                        <Form className="connector-configuration-form needs-validation" >
                                            {serviceList && serviceList["EFATURA"] &&
                                                <FormGroup row>
                                                    <Label sm={4} for="name">E Fatura XSLT </Label>
                                                    <Col xs="8">
                                                        <Select
                                                            name="invoiceXslt"
                                                            style={{
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'space-between'
                                                            }}
                                                            value={connectionInfo["invoiceXslt"]?connectionInfo["invoiceXslt"]:-1}
                                                            clearable={false}
                                                            clearValueText="Temizle"
                                                            placeholder="Seçiniz..."
                                                            options={serviceList["EFATURA"].xsltList.map(profileXslt => ({
                                                                value: profileXslt.recordId,
                                                                label: profileXslt.xsltFilename
                                                            }))}
                                                            onChange={(e) => this.onChangeXslt(e,'invoiceXslt')}>
                                                        </Select>
                                                    </Col>
                                                </FormGroup>
                                            }
                                            {serviceList && serviceList["EARSIV"] &&
                                                <FormGroup row>
                                                    <Label sm={4} for="name">E Arşiv XSLT </Label>
                                                    <Col xs="8">
                                                        <Select
                                                            name="archiveXslt"
                                                            style={{
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'space-between'
                                                            }}
                                                            value={connectionInfo["archiveXslt"]?connectionInfo["archiveXslt"]:-1}
                                                            clearable={false}
                                                            clearValueText="Temizle"
                                                            placeholder="Seçiniz..."
                                                            options={serviceList["EARSIV"].xsltList.map(profileXslt => ({
                                                                value: profileXslt.recordId,
                                                                label: profileXslt.xsltFilename
                                                            }))}
                                                            onChange={(e) => this.onChangeXslt(e,'archiveXslt')}>
                                                        </Select>
                                                    </Col>
                                                </FormGroup>
                                            }
                                            {serviceList && serviceList["EIRSALIYE"] &&
                                                <FormGroup row>
                                                    <Label sm={4} for="name">E İrsaliye XSLT </Label>
                                                    <Col xs="8">
                                                        <Select
                                                            name="despatchXslt"
                                                            style={{
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'space-between'
                                                            }}
                                                            value={connectionInfo["despatchXslt"]?connectionInfo["despatchXslt"]:-1}
                                                            clearable={false}
                                                            clearValueText="Temizle"
                                                            placeholder="Seçiniz..."
                                                            options={serviceList["EIRSALIYE"].xsltList.map(profileXslt => ({
                                                                value: profileXslt.recordId,
                                                                label: profileXslt.xsltFilename
                                                            }))}
                                                            onChange={(e) => this.onChangeXslt(e,'despatchXslt')}>
                                                        </Select>
                                                    </Col>
                                                </FormGroup>
                                            }
                                            {serviceList && serviceList["EMM"] &&
                                                <FormGroup row>
                                                    <Label sm={4} for="name">Müstahsil Makbuz XSLT </Label>
                                                    <Col xs="8">
                                                        <Select
                                                            name="voucherXslt"
                                                            style={{
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'space-between'
                                                            }}
                                                            value={connectionInfo["voucherXslt"]?connectionInfo["voucherXslt"]:-1}
                                                            clearable={false}
                                                            clearValueText="Temizle"
                                                            placeholder="Seçiniz..."
                                                            options={serviceList["EMM"].xsltList.map(profileXslt => ({
                                                                value: profileXslt.recordId,
                                                                label: profileXslt.xsltFilename
                                                            }))}
                                                            onChange={(e) => this.onChangeXslt(e,'voucherXslt')}>
                                                        </Select>
                                                    </Col>
                                                </FormGroup>
                                            }
                                        </Form>
                                    </div>
                                </div>
                                <div className={"tab-pane " + (this.state.activeTab === 'birimleriYonet' ? 'active' : '')} id="birimleriYonet">
                                    {connectionInfo && connectionInfo.erpUnitList && connectionInfo.erpUnitList.length > 0 &&
                                        <div className="card">
                                            <div className="card-header">
                                                <h4 className="card-title">Kaydedilenler</h4>
                                            </div>
                                            <div className="card-body">
                                                <div className="col-sm-12">
                                                    <table className="" style={{textAlign: 'center'}}>
                                                        <thead>
                                                        <tr style={{backgroundColor: '#ebedf0'}}>
                                                            <th width="2%">#</th>
                                                            <th width="10%">Erp Birim Adı</th>
                                                            <th width="10%">Erp Birim Kodu</th>
                                                            <th width="10%">Birim</th>
                                                            <th width="10%">İşlemler</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        {connectionInfo.erpUnitList && connectionInfo.erpUnitList.length > 0 && connectionInfo.erpUnitList.map((unit,index)=>
                                                            <tr key={index}>
                                                                <td className="form-group">{index + 1}</td>
                                                                <td className="form-group">{unit.erpUnitName}</td>
                                                                <td className="form-group">{unit.erpUnitCode}</td>
                                                                <td className="form-group">{this.unitNameConverter(unit.unitCode)}</td>
                                                                <td className="form-group">
                                                                    <button type="button"
                                                                            onClick={e=>{this.deleteUnit(unit)}}
                                                                            data-toggle="tooltip" data-placement="bottom" title="Temizle"
                                                                            style={{background: 'linear-gradient(rgb(236 92 92 / 57%), rgb(255 66 66))'}}
                                                                            rel="tooltip" className="Btn  btn-icon">
                                                                        <i style={{fontSize:"0.9rem"}} className="BtnIcon fa fa-trash-alt"/>
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        )}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    <div className="row">
                                        <div className="col-sm-6">
                                            {status && status.message &&
                                                <div>
                                                    <span style={{display:"inline-block"}}>Durum: </span>
                                                    {status.state == 'connected' && <i className="fa fa-circle" style={{color:"green"}}></i>}
                                                    {status.state == null && <i className="fa fa-circle" style={{color:"#fcba03"}}></i>}
                                                    {status.state == 'disconnected' && <i className="fa fa-circle" style={{color:"red"}}></i>}
                                                    {status.state == 'ok' && <i className="fa fa-circle" style={{color:"green"}}></i>}

                                                    <span style={{display:"block"}}>Bilgi: {status.message}</span>
                                                </div>
                                            }
                                        </div>
                                        <div className="col-sm-6">
                                            <div onClick={()=>this.getUnitSql()}
                                                 className="btn btn-primary pull-right" style={{fontSize:"0.8rem",background: "rgb(107, 208, 243)"}}>
                                                <i className="fa fa-search" style={{}}></i>
                                                <span style={{marginLeft:"10px"}}>Birimleri Getir </span>
                                            </div>
                                        </div>
                                    </div>
                                    {filteredUnitList &&
                                        <div className="card">
                                            <div className="card-header d-flex justify-content-between">
                                                <h4 className="card-title">Erp Birim Listesi</h4>
                                                <div>
                                                    <i className="fa-solid fa-magnifying-glass"></i>
                                                    <input type="text" className="form-control" placeholder="Filtrele..." onChange={e=>this.erpFilter(e)}/>
                                                </div>
                                            </div>
                                            <div className="card-body">
                                                <div className="col-sm-12">
                                                    <table className="" style={{textAlign: 'center'}}>
                                                        <thead>
                                                        <tr style={{backgroundColor: '#ebedf0'}}>
                                                            <th width="2%">#</th>
                                                            <th width="10%">Erp Birim Adı</th>
                                                            <th width="10%">Erp Birim Kodu</th>
                                                            <th width="10%">Birim</th>
                                                            <th width="10%">İşlemler</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        {filteredUnitList && filteredUnitList.length > 0 && filteredUnitList.map((unit,index)=>
                                                            <tr key={index}>
                                                                <td className="form-group">{index + 1}</td>
                                                                <td className="form-group">{unit.erpUnitName}</td>
                                                                <td className="form-group">{unit.erpUnitCode}</td>
                                                                <td data-label={"Birim"}>
                                                                    <Select
                                                                        id={'unit_' + index}
                                                                        placeholder="Birim Seçiniz"
                                                                        value={unit.unitCode}
                                                                        clearable={false}
                                                                        style={{width: "100%"}}
                                                                        noResultsText="Sonuç yok"
                                                                        onChange={(e) => e && this.onChangeUnit(e, index)}
                                                                        options={this.state.unitCodes.map(unitCode => ({
                                                                            value: unitCode.shortCode,
                                                                            label: unitCode.longCode
                                                                        }))}
                                                                    />
                                                                </td>
                                                                <td className="form-group">
                                                                    <button type="button"
                                                                            onClick={e=>{this.saveUnit(unit,index)}}
                                                                            data-toggle="tooltip" data-placement="bottom" title="Ekle"
                                                                            style={{background: 'linear-gradient(rgb(120, 177, 215), rgb(120, 177, 215))'}}
                                                                            rel="tooltip" className="Btn  btn-icon"
                                                                            disabled={unit.unitCode==null}>
                                                                        <i style={{fontSize:"0.9rem"}} className="BtnIcon fa fa-plus"/>
                                                                    </button>

                                                                </td>
                                                            </tr>
                                                        )}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </div>

                                <div className={"tab-pane " + (this.state.activeTab === 'HesapPlani' ? 'active' : '')} id="HesapPlani">
                                    {hesapPlaniOwnList && hesapPlaniOwnList.length > 0 &&
                                        <div className="card">
                                            <div className="card-header" style={{marginBottom: '10px'}}>
                                                <div>
                                                    <h4 className="card-title">Kaydedilenler</h4>
                                                </div>
                                                <div>
                                                    <input type={"checkbox"}
                                                           checked={this.state.selectedStok}
                                                        // style={{float: 'right'}}
                                                           onChange={this.onChangeStokSelected}/>
                                                    <h9>Stoklu Muhasebe Kaydı Oluştur.</h9>
                                                </div>
                                            </div>
                                            <div className="card-body">
                                                <div className="col-sm-12">
                                                    <table className="" style={{textAlign: 'center'}}>
                                                    <thead>
                                                        <tr style={{backgroundColor: '#ebedf0'}}>
                                                            <th width="2%">#</th>
                                                            <th width="10%">Kod</th>
                                                            <th width="10%">Açıklama</th>
                                                            <th width="10%">Hesap Kodu</th>
                                                            <th width="10%">Hesap Adı</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        {hesapPlaniOwnList && hesapPlaniOwnList.length > 0 && hesapPlaniOwnList.map((hesapPlaniOwn,index)=>
                                                            <tr key={index}>
                                                                <td className="form-group">{index + 1}</td>
                                                                <td className="form-group">{hesapPlaniOwn.kod}</td>
                                                                <td className="form-group">{hesapPlaniOwn.aciklama}</td>

                                                                <td className={"form-group"}>
                                                                   <Select
                                                                       clearable={true}
                                                                       multi={false}
                                                                       className="select-control"
                                                                       ignoreAccents={false}
                                                                       id={'hesapKodu_' + index}
                                                                       value={{
                                                                           value: hesapPlaniOwn.hesapKodu,
                                                                           label: hesapPlaniOwn.hesapKodu
                                                                       }}
                                                                       onChange={e => this.onHesapPlaniChange(e, index)}
                                                                       onInputChange={(key) => this.getHesapPlani(key)}
                                                                       isLoading={false}
                                                                       autoload={false}
                                                                       cache={false}
                                                                       noResultsText="Kayıt bulunamadı."
                                                                       searchPromptText="Arama için en az 1 karakter giriniz."
                                                                       placeholder="HesapPLanı Açıklaması veya Kodu ile arama yapabilirsiniz"
                                                                       loadingPlaceholder="Yükleniyor..."
                                                                       showNewOptionAtTop={false}
                                                                       arrowRenderer={this.arrowRenderer}
                                                                       onCloseResetsInput={false}
                                                                       onSelectResetsInput={false}
                                                                       onBlurResetsInput={false}
                                                                       options={this.state.hesapPlaniValues}
                                                                    />
                                                                </td>
                                                                <td className="form-group">{hesapPlaniOwn.hesapAdi}</td>
                                                            </tr>

                                                        )}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </div>

                            </div>
                        </div>
                    </div>
                }

            </ModalBody>
            <ModalFooter>

                <div className="col-sm-12 row">
                    <div className="col-sm-2 ">
                        <button type="button" data-toggle="tooltip" data-placement="bottom"
                                style={{
                                    background: 'linear-gradient(rgba(125, 125, 125, 0.57), rgb(111, 111, 111))',
                                    padding: '10px 54px 10px 23px'
                                }}
                                rel="tooltip" className="TekBtn vazgec btn-icon"
                                onClick={()=>{this.props.toggle(); this.clearInputs()}}>
                            İptal
                        </button>
                    </div>
                    <div className="col-sm-8 "></div>

                    <div className="col-sm-2 ">

                        <button type="button" data-toggle="tooltip" data-placement="bottom"
                                style={{
                                    background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)',
                                    padding: '10px 54px 10px 23px',
                                    float:'right'
                                }}
                                rel="tooltip" className="TekBtn kaydet btn-icon"
                                disabled={selectedBranchId==null || Object.keys(connectionInfo).length === 0}
                                onClick={() => {this.saveClicked()}}>
                            Kaydet
                        </button>
                    </div>
                </div>
            </ModalFooter>
        </Modal>
        )
    }
}

export default ConnectorConfigurationModal;